import z from 'zod';
import { v4 as uuidv4 } from 'uuid';
import { customEventBaseFields, kebabString } from './base-fields';

export const frame = {
  ...customEventBaseFields,
  type: kebabString.describe('the functional type of the frame'),
  id: z.string().describe('identifies the frame').optional(),
  frameType: z.enum(['widget', 'confirmation', 'pop-up']),
};

export default {
  opened: z.object({
    ...frame,
    frameCorrelationId: z.string().default(() => uuidv4()),
  }),
  closed: z.object({
    ...frame,
    result: z.enum(['confirmed', 'rejected', 'cancelled']).optional(),
    frameCorrelationId: kebabString,
  }),
  moved: z.object({
    ...frame,
    locationX: z.number().int().optional(),
    locationY: z.number().int().optional(),
    frameCorrelationId: kebabString,
  }),
};
